@if (
  {
    task: task$ | async,
    projectsMap: projectsMap$ | async,
    coinTypesMap: coinTypesMap$ | async,
    loading: loading$ | async
  };
  as state
) {
  @if (state.loading) {
    <div class="oph-loading-container">
      <oph-loading></oph-loading>
    </div>
  } @else if (state.task && state.projectsMap && state.coinTypesMap) {
    <oph-back-button (buttonClick)="onBack()"></oph-back-button>

    <current-sked-task-detail-info
      [task]="state.task"
      [project]="state.projectsMap[state.task.projectId]"
      [coinTypeName]="state.coinTypesMap[state.task.taskCoinType]?.name"
      [isMobile]="true"
    ></current-sked-task-detail-info>
  }
}
